/**
 * All Regions to check for DNS look up.
 */
enum Region {
  US = 'US',
  EU = 'EU',
  AUS = 'AUS',
  IN = 'IN',
  MEC = 'MEC'
}

/**
 * Promise States for Promise.allSettled
 */
enum PromiseState {
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}
export interface DNSLookUpTest {
  url: string;
  reachable: boolean;
}
export interface DNSLookupTestResults {
  totalDomains: number;
  domainsReachable: number;
  individualTestResults: Array<DNSLookUpTest>;
}

export { Region, PromiseState };
